export class Constants {
  public static EnrollmentEnabled = 'EnrollmentEnabled';
  public static EarlyEnrollment = 'EarlyEnrollment';
  public static AutoConversionEnabled = 'AutoConversionEnabled';
  public static EmailNotificationEnabled = 'EmailNotificationEnabled';
  public static WaiverManagement = 'WaiverManagement';
  public static ClaimsManagement = 'ClaimsManagement';
  public static PaymentManagement = 'PaymentManagement';
  public static InsuranceManagement = 'InsuranceManagement';
  public static SchoolSetup = 'SchoolSetup';

  //Waiver Status
  public static WaiverStatusInReview = 'In Review';
  public static AppealInReviewStatus = 'Appeal In Review';
  public static ApprovedUponAppealStatus = 'Approved Upon Appeal';
  public static DeclineUpheldStatus = 'Decline Upheld';
  public static PendingVerificationStatus = 'Pending Verification';
  public static UnableToVerifyStatus = 'Unable to Verify';
  public static PendingCOCVerificationStatus = 'Pending COC Verification';
  public static PendingIDCardVerificationStatus = 'Pending ID Card Verification';
  public static ApprovedVerificationStatus = 'Approved Verification';
  public static DeclinedVerificationStatus = 'Declined Verification';
  public static WaiverStatusDeclined = 'Declined';

  // View Waiver Card
  public static internalAdminCoverageCheckList = ['Declined', 'Void', 'Declined Verification'];
  public static internalVerifAdminCoverageCheckList = ['Declined', 'Declined Verification', 'Decline Upheld'];
  public static clientAdminCoverageCheckList = ['Declined', 'Void', 'Declined Verification', 'Decline Upheld'];

  //ArchiveStudents  
  public static ArchiveStudentsNotice = 'You have chosen to archive these students. Once submitted, these students will no longer be available within Partner Center. Would you like to continue?';

  //Appeal status
  public static AppealPending = 'Appeal Pending';
  public static AppealRequestedInfo = 'Appeal Requested Info';
  public static AppealApproved = 'Appeal Approved';
  public static AppealDeclined = 'Appeal Declined';
  public static AppealAdminReview = 'Appeal Admin Review';

  //Page Headers
  public static ViewArchivedStudents = 'View Archived Student Waiver';
  public static ViewStudentWaiver = 'View Student Waiver';

  public static AppealInReviewStatusId = '13';
  public static PendingVerificationStatusId = '8';
  public static PendingCOCVerificationStatusId = '11';
  public static PendingIDCardVerificationStatusId = '12';
  // block name constants
  public static ScheduleEmailNotificationsBlockName = 'Schedule Email Notifications';
  public static LedgerBillingBlockName = 'Ledger Billing';
  public static Referrals = 'Referrals';

  public static ScheduleEmailNotifications = 'ScheduleEmailNotifications';
  public static LedgerBilling = 'LedgerBilling';

  // router Paths
  public static WaiverManagementPath = 'waiver-management';
  public static PaymentPath = 'payment';
  public static InsuranceManagementPath = 'insurance-management';
  public static ClaimsPath = 'claims-management';
  public static SchoolSetupPath = 'school-setup';

  // report types
  public static WaiverConfiguration = 'WaiverConfiguration';
  public static WaiverConfigurationText = 'Waiver Configuration';
  public static PolicyConfigurationText = 'Policy Configuration';
  public static PrintStudentWaiverData = 'printStudentWaiverData';
  //Approve Coverage Messages
  public static PendingCoverage = 'There are students with Pending coverage. Do you want to approve now?';
  public static BulkPendingCoverage = `Coverage will be approved for ## records. Click Ok to confirm.`;
  public static ApproveCoverage = 'Are you sure you want to {0} for {1} ?';
  public static ManageSHCBilling = 'Manage SHC Billing';
  public static ManageReferrals = 'Manage Referrals';

  public static BasicMedicalInsuranceTypeLabel = 'Medical';

}
export enum ProcessImportStudentResults {
  GenericError = 0,
  NoCorrectableErrors = 1,
  ExsistCorretableErrors = 2,
}
export enum ImportStudentOptions {
  InitialIncrementalImport = 1,
  ReconciliationImport = 2,
}
export enum EmailtemplateTypes {
  WaiverNotification = 1,
  WaiverReminder = 2,
  EnrollmentNotification = 3
}

export enum AddressTypeCodes {
  MailingAddress = 'MAIL',
  PermanentAddress = 'PERM'
}

export enum PatientType {
  Student = 1,
  Spouse = 2,
  Child = 0 //As we are not capturing which child (child1, child2 etc), set this value as undetermined
}
